import { includes, isEmpty, map } from "lodash";
import classNames from "classnames";
import {
  faCalendarPlus,
  faFont,
  faQuestion,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormContext } from "react-hook-form";
import { stringify } from "query-string";

type TypeSelectorArgs = {
  selectedType: string;
  setType: (type: string) => void;
};

export default function TypeSelector({
  selectedType,
  setType,
}: TypeSelectorArgs) {
  const { watch } = useFormContext();
  const ICON_LOOKUP = {
    note: faFont,
    question: faQuestion,
    appointment: faCalendarPlus,
  };
  const selectableTypes = ["note", "question"];
  const streams = watch("activitystreams");
  const content = watch("object.content");

  if (includes(Preload.current_network.availableModules, "Calendars"))
    selectableTypes.push("appointment");

  function createAppointment() {
    window.InterceptorPrompt.allowNavigation();

    const params = {
      post_to_stream: true,
    };

    if (!isEmpty(streams)) params["streams"] = map(streams, "value").join(",");

    if (!isEmpty(content)) params["description"] = content;

    // Workaround to disable interceptor for appointment creation
    window.location.href = `/appointments/new?${stringify(params)}`;
  }

  return (
    <div className="type-selector flex gap-2 items-center">
      {map(selectableTypes, (type) => (
        <button
          key={type}
          className={classNames("btn btn-light btn-sm", {
            active: type === selectedType,
          })}
          type="button"
          onClick={(e) => {
            e.preventDefault();
            type === "appointment" ? createAppointment() : setType(type);
          }}
        >
          <FontAwesomeIcon
            className="mr-1 text-primary"
            icon={ICON_LOOKUP[type]}
          />
          {I18n.t(`js.composer.editor.${type}.label`)}
        </button>
      ))}
    </div>
  );
}
